module.exports = __webpack_public_path__ + "img/infographicHowWeTestVertical.65902bce.png";